/**
 * ObjectKey
 * TODO - add CrmObjectKey to ObjectKey typing here to begin enforcing generics
 * @description ObjectKey is the shape of identifiers used for realtime and API
 * response based view members.
 */

/**
 * CrmObjectKey
 *
 * @description CrmObjectKey is the object identifier used for CRM objects.
 */

/**
 * ThreadKey
 *
 * @description Object identifier for threads, including the Conversation CRM
 * object ID whenever it's available. There is no Conversation CRM object when
 * a thread is soft deleted or filtered/spam, and in the event of a CRM outage
 * we also lose access to it, so these CRM object key properties should be used
 * carefully with that in mind.
 */

/**
 * isThreadKey
 *
 * @description This type guard will assert if the given object key is a ThreadKey.
 */
export function isThreadKey(objectKey) {
  return objectKey['@type'] === 'THREAD_KEY';
}